export default import.meta.ROLLDOWN_FILE_URL_SPTFa08Q0Hys_vMs1FbGpg